module.exports = __webpack_public_path__ + "img/ic_32_profile_zugangsdaten.26b868f1.svg";